import { useAuthClaims } from 'hooks/useAuthClaims';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { useRequireParams } from 'hooks/useRequireParams';
import { BpSubpage } from '../../../components/BpSubpage/BpSubpage';
import { CourseOverviewStudentContent } from './StudentContent/CourseOverviewStudentContent';
import { CourseOverviewTeacherContent } from './TeacherContent/CourseOverviewTeacherContent';

export const CourseOverviewSubpage = () => {
  const { pimAuthClaims } = useAuthClaims();
  const { courseUuid } = useRequireParams(['courseUuid']);

  const permissions = usePermissionChecker();

  const canCreate = permissions?.canCreateAssignment({
    uuid: courseUuid,
    organization: { uuid: pimAuthClaims.getOrganizationUuid() },
  });

  return <BpSubpage>{canCreate ? <CourseOverviewTeacherContent /> : <CourseOverviewStudentContent />}</BpSubpage>;
};
